/** Sample motion entries for unauthenticated dashboard previews (shape matches live API). */

export const PREVIEW_PATIENT_A = "preview.patient@mrehab.local";
export const PREVIEW_PATIENT_B = "preview.carepartner@mrehab.local";

function isoDaysAgo(days: number): string {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() - days);
  d.setUTCHours(14, 30, 0, 0);
  return d.toISOString();
}

export type PreviewEntry = {
  Timestamp: string;
  ExerciseName: string;
  Hand: string;
  Accuracy: number;
  Reps: number;
  Duration: number;
  PatientEmail: string;
};

const baseEntries: PreviewEntry[] = [
  {
    Timestamp: isoDaysAgo(1),
    ExerciseName: "Vertical Mug",
    Hand: "Right",
    Accuracy: 88,
    Reps: 12,
    Duration: 42,
    PatientEmail: PREVIEW_PATIENT_A,
  },
  {
    Timestamp: isoDaysAgo(3),
    ExerciseName: "Vertical Mug",
    Hand: "Right",
    Accuracy: 82,
    Reps: 10,
    Duration: 38,
    PatientEmail: PREVIEW_PATIENT_A,
  },
  {
    Timestamp: isoDaysAgo(5),
    ExerciseName: "Vertical Mug",
    Hand: "Right",
    Accuracy: 79,
    Reps: 9,
    Duration: 41,
    PatientEmail: PREVIEW_PATIENT_A,
  },
  {
    Timestamp: isoDaysAgo(2),
    ExerciseName: "Horizontal Bowl",
    Hand: "Both",
    Accuracy: 91,
    Reps: 8,
    Duration: 36,
    PatientEmail: PREVIEW_PATIENT_A,
  },
  {
    Timestamp: isoDaysAgo(4),
    ExerciseName: "Vertical Mug",
    Hand: "Left",
    Accuracy: 74,
    Reps: 11,
    Duration: 44,
    PatientEmail: PREVIEW_PATIENT_B,
  },
  {
    Timestamp: isoDaysAgo(6),
    ExerciseName: "Vertical Mug",
    Hand: "Left",
    Accuracy: 70,
    Reps: 7,
    Duration: 33,
    PatientEmail: PREVIEW_PATIENT_B,
  },
];

export function filterPreviewEntries(
  patientEmail: string,
  hand: string,
  exerciseName: string
): PreviewEntry[] {
  return baseEntries.filter(
    (e) =>
      e.PatientEmail === patientEmail &&
      (exerciseName.toLowerCase().includes("bowl") || e.Hand === hand) &&
      e.ExerciseName === exerciseName
  );
}

export function toGraphEntries(rows: PreviewEntry[]): Record<string, unknown>[] {
  return rows.map(({ PatientEmail: _p, ...rest }) => rest);
}

export const PREVIEW_PROVIDER_DEMO_PATIENTS: { email: string; label: string }[] = [
  { email: PREVIEW_PATIENT_A, label: "Preview patient A" },
  { email: PREVIEW_PATIENT_B, label: "Preview patient B" },
];
